<template>
  <div>


      <h2 class="goth">Presens av sein</h2>

      <h4>sein = vara (grunform av "är")</h4>
          <p class="grammatikparagrafbredd leftorient">När man på svenska använder ordet <b>är</b>, använder man på tyskan många olika former av
              ordet beroende på vad som är subjekt, d.v.s. vem, vad eller vilka som "är".</p><br>


    <table class="">


        <tr class="leftorient">
            <td class="ljusgra">ich</td>
            <td class="ljusgra"><i><b>bin</b></i></td>
        </tr>

        <tr class="leftorient">
            <td class="ljusgra">du</td>
            <td class="ljusgra"><i><b>bist</b></i></td>
        </tr>

        <tr class="leftorient">
            <td class="ljusgra">er<br> es<br> sie</td>
            <td class="ljusgra"><i><b>ist</b></i></td>
        </tr>

        <tr class="leftorient">
        </tr>


        <tr class="leftorient">
            <td class="upperspace ljusgra">wir</td>
            <td class="ljusgra"><i><b>sind</b></i></td>
        </tr>

        <tr class="leftorient">
            <td class="ljusgra">ihr</td>
            <td class="ljusgra"><i><b>seid</b></i></td>
        </tr>

        <tr class="leftorient">
            <td class="ljusgra">sie<br> Sie</td>
            <td class="ljusgra"><i><b>sind</b></i></td>
        </tr>


    </table>

<br><br>
<div class="ruta leftorient">
<p><i><b>Ich bin</b> sehr froh.<br>Jag är väldigt glad.</i></p>

<p><i><b>Bist du</b> allein?<br>Är du ensam?</i></p>

<p><i><b>Er ist</b> mein Bruder.<br>Han är min bror.</i></p>

<p><i><b>Wir sind</b> begeistert.<br>Vi är hänförda.</i></p>

<p><i><b>Ihr seid</b> fleißig.<br>Ni är flitiga.</i></p>

<p><i><b>Sie sind</b> weit weg.<br>De är långt borta.</i></p>

<p><i><b>Sind Sie </b>zufrieden, Frau Schneider?<br>Är ni nöjd, fru Schneider?</i></p>

</div>

<br><br><br>
    <br><div class="grammatikparagrafbredd leftorient quasi-p">
        Tänk på att i formen <b><i><b>ist</b></i></b> används för allt som är <b>tredje person i singular</b>
        (inte bara vid pronomina <i>er</i>, <i>es</i> eller <i>sie</i>). <br>
</div>

        <br>

<div class="ruta leftorient">

        <p><i>Meine Mutter <b>ist</b> groß.<br>Min mamma är stor.</i> </p>

        <p><i>Das Buch  <b>ist</b> wirklich gut groß.<br>Boken är verkligen bra.</i> </p>

        <p><i>Der Wagen <b>ist</b> schnell.<br>Bilen är snabb.</i> </p>




</div>
        <br>
            <br><p class="leftorient">Likaså används formen <i><b>sind</b></i>
             för allt som är <b>tredje person i plural</b></p>


                <div class="ruta leftorient">

<p><i>Alle Kinder <b>sind</b> froh.<br>Alla barn är glada.</i> </p>

<p><i>Meine Bücher <b>sind</b> interessant.<br>Mina böcker är intressanta.</i> </p>


    </div>
</div>


</template>

<script>
export default {
  name: 'Grammatik',
  props: {
    msg: String
},

metaInfo() {
    return {
        meta: [
            {
                vmid: "description",
                name: "description",
                content: "presens av sein är"
            }
        ]
    }
},


}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
